/* eslint-disable no-undef */
/* eslint-disable no-undef */
import intlTelInput from "/Assets/libs/intl-tel-input/js/intlTelInput.js";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-phone-number-element] [data-phone-input]").forEach(element => {
        new PhoneNumberElementPlugin(element);
    });
});

class PhoneNumberElementPlugin {
    constructor(element, options = {}) {
        this.element = element;
        this.options = { ...PhoneNumberElementPlugin.defaults, ...options };
        this.iti = null;
        this.init();
    }

    static get defaults() {
        return {};
    }

    init() {
        this.iti = intlTelInput(this.element, {
            loadUtils: () => import("/Assets/libs/intl-tel-input/js/utils"),
            nationalMode: false,
            separateDialCode: true,
            excludeCountries: ["ac", "bq", "ss", "gg"],
            i18n: window.localizedCountries,
            initialCountry: window.initialCountry
        });

        this.element.addEventListener("blur", this.updateHiddenInput);
        this.element.addEventListener("keyup", this.updateHiddenInput);
        this.element.addEventListener("countrychange", this.handleCountryChange);
    }

    updateHiddenInput = (event) => {
        const number = this.iti.getNumber();
        const hiddenInput = event.target.closest("[data-phone-number-element]").querySelector("[data-f-datainput]");
        hiddenInput.value = number;
    }

    handleCountryChange = () => {
        this.iti.setNumber("");
    }
}
